import {createStyles, makeStyles} from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    highlight: {
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      height: 160,
      width: 160,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    value: {
      lineHeight: '32px',
      paddingTop: '8px',
    },
  })
);
